import React, { FunctionComponent } from 'react'
import SectionLoader from './sectionLoader'

export interface Props {
  isLoading: boolean
  children: React.ReactNode
}

const LoadingSection: FunctionComponent<Props> = ({ isLoading, children }) => (
  <>
    <SectionLoader isLoading={isLoading} />
    <div style={{ display: isLoading ? 'none' : 'block' }}>{children}</div>
  </>
)

export default LoadingSection
